module.exports = __webpack_public_path__ + "img/roompage_logo.7afb6503.svg";